var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChat = function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#AAA6A6",
    d: "M7 18h.75a.75.75 0 0 0-.75-.75zm0 3.5h-.75a.75.75 0 0 0 1.23.576zm4.2-3.5v-.75a.75.75 0 0 0-.48.174zM3 5h.75A.25.25 0 0 1 4 4.75v-1.5A1.75 1.75 0 0 0 2.25 5zm0 12h.75V5h-1.5v12zm1 1v-.75a.25.25 0 0 1-.25-.25h-1.5c0 .966.784 1.75 1.75 1.75zm3 0v-.75H4v1.5h3zm0 0h-.75v3.5h1.5V18zm0 3.5.48.576 4.2-3.5L11.2 18l-.48-.576-4.2 3.5zM20 18v-.75h-8.8v1.5H20zm1-1h-.75a.25.25 0 0 1-.25.25v1.5A1.75 1.75 0 0 0 21.75 17zm0-12h-.75v12h1.5V5zm-1-1v.75a.25.25 0 0 1 .25.25h1.5A1.75 1.75 0 0 0 20 3.25zM4 4v.75h16v-1.5H4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#AAA6A6",
    strokeWidth: 1.5,
    d: "M7 8.75h10M7 12.75h7"
  })));
};
export default SvgChat;